import { useEffect, useState } from "react";
import axios from "axios";
import { X, FileText, ExternalLink } from "lucide-react";
import { AI2 } from "./api";
import { useEscape, paragraphs } from "./util";

export const SourceDialog = ({ source, onClose }) => {
  useEscape(onClose);
  const [doc, setDoc] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => {
    axios.get(`${AI2}/kb/${source.id}`).then((r) => setDoc(r.data)).catch(() => setErr("Couldn't open this document"));
  }, [source.id]);
  return (
    <div className="scrim" onClick={onClose} data-testid="ai2-source-dialog">
      <div className="dialog" style={{ maxWidth: 720 }} onClick={(e) => e.stopPropagation()}>
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 12 }}>
          <FileText size={16} color="#1F8A7C" />
          <h3 style={{ margin: 0, fontSize: 17, fontWeight: 800 }}>{source.title}</h3>
          <button className="btn btn-ghost btn-sm" style={{ marginLeft: "auto" }} onClick={onClose} aria-label="Close" data-testid="ai2-source-close"><X size={16} /></button>
        </div>
        {err && <div className="alert">{err}</div>}
        {!doc && !err && <div className="skeleton" style={{ height: 200, borderRadius: 8 }} />}
        {doc && (
          <div style={{ fontSize: 13, lineHeight: 1.6 }} data-testid="ai2-source-content">
            {paragraphs(doc.content).map((p, i) => <p key={i} style={{ margin: p.list ? "0 0 4px 12px" : "0 0 12px" }}>{p.text}</p>)}
          </div>
        )}
        {doc?.source_url && <a href={doc.source_url} target="_blank" rel="noreferrer" className="btn btn-sm" style={{ marginTop: 8, textDecoration: "none" }} data-testid="ai2-source-original"><ExternalLink size={12} />Open original document</a>}
      </div>
    </div>
  );
};
